import { AwardFragment, isAwardFragment } from './AwardFragment'

import awardGroupFragmentRawString from '../AwardGroupFragment.graphql'

export const awardGroupFragmentString = awardGroupFragmentRawString

export type AwardGroupFragment = {
  name: string
  imageUrl: string
  awards: AwardFragment[]
}

export const isAwardGroupFragment = (
  fragment: any,
): fragment is AwardGroupFragment =>
  fragment &&
  typeof fragment.name === 'string' &&
  typeof fragment.imageUrl === 'string' &&
  Array.isArray(fragment.awards) &&
  fragment.awards
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isAwardFragment(next) as boolean),
      true,
    )
